import { createTheme } from '@mui/material/styles';

// assets
import colors from 'assets/scss/_themes-vars.module.scss';

// project imports
import componentStyleOverrides from './compStyleOverride';
import themePalette from './palette';
import themeTypography from './typography';

/**
 * Represent theme style and structure as per Material-UI
 * @param {JsonObject} customization customization parameter object
 */

export const theme = (customization) => {
  const color = colors;

  const themeOption = {
    colors: color,
    heading: color.textPrimary,
    // `paper` is anything raised on top of the canvas — cards, table headers, menus.
    // `default` is the page canvas itself. These were both #544e63, so every surface
    // was the same shade and panels merged into one another (most obviously the chat
    // list and the conversation pane reading as a single window). They are now two
    // named rungs of the ladder in _themes-vars, so "raised" means one thing.
    paper: color.surface,
    backgroundDefault: color.canvas,
    background: color.canvas,
    // Primary text sits on the DARK panel, so it has to be light. This was previously
    // grey900/grey500 — both literally #ffffff, which meant primary and secondary text
    // were indistinguishable and there was no third step for disabled at all.
    darkTextPrimary: color.textPrimary,
    darkTextSecondary: color.textSecondary,
    textDark: color.textPrimary,
    menuSelected: color.accentText,
    menuSelectedBack: color.accentSoft,
    // Was grey200 (#e3e8ef) — a near-white hairline on a dark ground, louder than the
    // content it separated.
    divider: color.dividerDark,
    customization
  };

  // Brand accent for the whole panel. This was hard-coded to '#000' with a leftover
  // "replace with your desired shade of red" note, which is why every contained button,
  // toggle and primary accent rendered black and the panel looked unfinished. #673ab7 is
  // the purple already used by the sidebar selection, the breadcrumb home icon and the
  // dashboard Apply button — so one accent now, deliberately.
  themeOption.palette = {
    primary: {
      main: color.secondaryMain
    }
  };

  const themeOptions = {
    direction: 'ltr',
    palette: themePalette(themeOption),
    mixins: {
      toolbar: {
        minHeight: '48px',
        padding: '16px',
        '@media (min-width: 600px)': {
          minHeight: '48px'
        }
      }
    },
    typography: themeTypography(themeOption)
  };

  const themes = createTheme(themeOptions);
  themes.components = componentStyleOverrides(themeOption);

  return themes;
};

export default theme;
